import { WidgetConfigurationSlotRender } from '@framework/engine/schema/widgets/repository/common/config-slots/WidgetConfigurationSlotRender.tsx';
import { WidgetConfigurationSlots } from '@framework/engine/schema/widgets/repository/common/config-slots/WidgetConfigurationSlots.tsx';
import { SwitchInput } from '@framework/form/inputs/SwitchInput.tsx';
import { FormItem } from '@framework/form/item/FormItem.tsx';
import { SWITCH_EVIDENCE_CARD_LAYOUT } from '@framework/form/item/formItemLayouts.ts';
import { SwitchEvidenceCard } from '@framework/ui/components/configuration-card/SwitchEvidenceCard.tsx';
import { WidgetConfigurationSubCard } from '@framework/ui/components/configuration-card/widget/WidgetConfigurationSubCard.tsx';
import { TbIcon } from '@framework/ui/components/icon/TbIcon.tsx';
import { StyledTag } from '@framework/ui/components/tag/StyledTag.tsx';
import { IconEyeOff } from '@tabler/icons-react';
import { Flex, Tooltip } from 'antd';
import { useWatch } from 'react-hook-form';

export interface IOmissisDirectiveConfigComponentProps {
  name: string;
}

/**
 * Sub-card "Omissis": nasconde il valore del campo nella consultazione da
 * area pubblica. Il tipo di dati sensibili (`sensitiveType`) non è più
 * esposto in UI ma resta nello schema per compatibilità con i dati salvati.
 */
export function OmissisDirectiveConfigComponent(
  props: IOmissisDirectiveConfigComponentProps,
) {
  const omissis = useWatch({ name: `${props.name}.enabled` });

  return (
    <WidgetConfigurationSlotRender
      slot={WidgetConfigurationSlots.Semantic}
      order={40}
    >
      <WidgetConfigurationSubCard
        icon={<TbIcon icon={IconEyeOff} />}
        title="Omissis"
        anchorTitle="omissis"
        description="Permette di configurare la visibilità del dato in area pubblica."
        summary={
          <Tooltip
            title={
              omissis
                ? 'Il campo è nascosto in area pubblica: non sarà visibile durante la consultazione da parte di utenti terzi.'
                : 'Il campo è pubblico in area pubblica.'
            }
          >
            <StyledTag color={omissis ? 'red' : 'green'} tabIndex={0}>
              {omissis ? 'Dato Omissis' : 'Dato Pubblico'}
            </StyledTag>
          </Tooltip>
        }
      >
        <FormItem
          name={`${props.name}.enabled`}
          label="Omissis"
          layout={SWITCH_EVIDENCE_CARD_LAYOUT}
        >
          <SwitchEvidenceCard>
            <SwitchInput name={`${props.name}.enabled`} align="start">
              <Flex vertical>
                <b>Omissis: nascondi in area pubblica</b>
                <span>
                  Se impostato come nascosto, il dato non sarà visibile durante
                  la consultazione dall'area pubblica da parte di utenti terzi.
                </span>
              </Flex>
            </SwitchInput>
          </SwitchEvidenceCard>
        </FormItem>
      </WidgetConfigurationSubCard>
    </WidgetConfigurationSlotRender>
  );
}
